import { resolveApiBase, resolveApiOrigin } from './apiBase';

const RUNTIME_ORIGIN = window.location.origin;

export const API_BASE = resolveApiBase(process.env.REACT_APP_API_URL, RUNTIME_ORIGIN);
export const API_ORIGIN = resolveApiOrigin(API_BASE, RUNTIME_ORIGIN);
